const STORAGE_KEY = 'ct_e2ee_master_jwk';
const TRUSTED_DEVICE_STORAGE_KEY = 'ct_e2ee_master_jwk_trusted';
const RSA_PRIVATE_STORAGE_KEY = 'ct_e2ee_rsa_private_jwk';
const RSA_TRUSTED_STORAGE_KEY = 'ct_e2ee_rsa_private_jwk_trusted';

export function saveMasterKeyJwk(jwkJson: string): void {
  sessionStorage.setItem(STORAGE_KEY, jwkJson);
}

export function saveTrustedMasterKeyJwk(jwkJson: string): void {
  localStorage.setItem(TRUSTED_DEVICE_STORAGE_KEY, jwkJson);
}

export function getTrustedMasterKeyJwk(): string | null {
  return localStorage.getItem(TRUSTED_DEVICE_STORAGE_KEY);
}

export function promoteTrustedMasterKeyToSession(): string | null {
  const trusted = getTrustedMasterKeyJwk();
  if (trusted) {
    saveMasterKeyJwk(trusted);
    return trusted;
  }
  return null;
}

export function getMasterKeyJwk(): string | null {
  const inSession = sessionStorage.getItem(STORAGE_KEY);
  if (inSession) {
    return inSession;
  }
  return promoteTrustedMasterKeyToSession();
}

export function clearMasterKey(clearTrusted = false): void {
  sessionStorage.removeItem(STORAGE_KEY);
  if (clearTrusted) {
    localStorage.removeItem(TRUSTED_DEVICE_STORAGE_KEY);
    localStorage.removeItem(RSA_TRUSTED_STORAGE_KEY);
  }
}

export function saveRsaPrivateJwk(jwkJson: string): void {
  sessionStorage.setItem(RSA_PRIVATE_STORAGE_KEY, jwkJson);
}

export function saveTrustedRsaPrivateJwk(jwkJson: string): void {
  localStorage.setItem(RSA_TRUSTED_STORAGE_KEY, jwkJson);
}

export function getRsaPrivateJwk(): string | null {
  const inSession = sessionStorage.getItem(RSA_PRIVATE_STORAGE_KEY);
  if (inSession) {
    return inSession;
  }
  const trusted = localStorage.getItem(RSA_TRUSTED_STORAGE_KEY);
  if (trusted) {
    saveRsaPrivateJwk(trusted);
    return trusted;
  }
  return null;
}
